import React from 'react';
import { BadgeCheck, Info } from 'lucide-react';
import { Tooltip } from 'react-tooltip';
import OperatingSystemTag from './common/OperatingSystemTag';
import { formatCentsAsUSD } from '../../lib/currency';
import {
  WHITE_LABEL_ACCENT_COLOR,
  WHITE_LABEL_BRAND,
} from '../../lib/white-label';

export const BotListCard = ({ bot }) => {
  return (
    <div className="bg-white p-3 border rounded shadow flex flex-col transition hover:scale-[1.02] relative">
      <div className="flex items-center mb-2 justify-center gap-4">
        <img
          src={bot.imageUrl}
          alt={bot.name}
          className="w-16 h-16 object-cover rounded-md mr-2"
        />
        <div className="flex-row text-center">
          <p className="font-bold text-sm truncate flex justify-center items-center line-clamp-2">
            {bot.name}
            {bot.listingMode === 'DIRECT' && (
              <span className="pl-1 pb-1">
                <BadgeCheck
                  size={20}
                  data-tooltip-content={`Partnered with ${WHITE_LABEL_BRAND}`}
                  data-tooltip-id={`${bot.name}-partner-tooltip`}
                  color={'#FFFFFF'}
                  fill={WHITE_LABEL_ACCENT_COLOR}
                />
                <Tooltip id={`${bot.name}-partner-tooltip`} place="left" />
              </span>
            )}
          </p>
          <div className="flex gap-1 mt-1 justify-center">
            {bot?.operatingSystem?.split(',')?.map((o, index) => (
              <OperatingSystemTag key={index} text={o} iconOnly />
            ))}
          </div>
        </div>
      </div>
      <div className="flex-grow flex flex-col justify-between">
        <div className="text-xs text-gray-500 flex items-center justify-center gap-4">
          <span>Last Sale</span>
          <span className="font-semibold text-sm">
            {bot.lastRental
              ? `${formatCentsAsUSD(
                  bot.lastRental.priceCents * bot.lastRental.rentalDays,
                )} / ${bot.lastRental.rentalDays} day${
                  bot.lastRental.rentalDays > 1 ? 's' : ''
                }`
              : 'N/A'}
          </span>
        </div>
        <div
          className="text-xs p-1 rounded text-center mt-2"
          style={{
            color: WHITE_LABEL_ACCENT_COLOR,
            borderColor: WHITE_LABEL_ACCENT_COLOR,
            backgroundColor: `${WHITE_LABEL_ACCENT_COLOR}10`,
          }}
        >
          {bot.status === 'ACTIVE'
            ? `${bot.listingsCount} LISTING${
                bot.listingsCount !== 1 ? 'S' : ''
              }`
            : 'COMING SOON'}
        </div>
      </div>
      {/* <div className="absolute top-1 right-1">
        <Tooltip id={`${bot.name}-info-tooltip`} place="left">
          <div className="text-xs">
            <p>Status: {bot.status}</p>
          </div>
        </Tooltip>
        <Info
          size={16}
          className="text-gray-400 cursor-pointer"
          data-tooltip-id={`${bot.name}-info-tooltip`}
        />
      </div> */}
    </div>
  );
};
